import { FormControl, InputLabel, makeStyles } from "@material-ui/core";
import React from "react";
import { FilePicker } from "../../Inputs";
const useStyles = makeStyles((theme) => ({
    formControll: {
        marginTop: "20px",
        "& .MuiInputLabel-formControl": {
            top: "-20px",
            zIndex: 1,
        },
        "& .filepond--root": {
            marginBottom: 0,
            marginTop: "20px",
        },
    },
}));
export const AdminFormFilePicker = (props) => {
    const classes = useStyles();
    const { name, acceptedFileTypes, label, folder, onChange, required, file, } = props;
    return (React.createElement(FormControl, { variant: "filled", fullWidth: true, className: classes.formControll },
        React.createElement(InputLabel, { variant: "filled" }, label && label),
        React.createElement(FilePicker, { name: name && name, acceptedFileTypes: acceptedFileTypes && acceptedFileTypes, folder: folder && folder, onChange: onChange && onChange, required: required && required, file: file && file })));
};
//# sourceMappingURL=AdminFormFilePicker.js.map